import React from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";

function assetNameRenderer({data}){
    if(data){
        const length = data.length;
        if(length > 0) {
            const str = data.length <= 1 ? data[0].asset?.assetName : (data[0].asset?.assetName + " 외 " + (length - 1) + "개");
            return(
                str
            )
        }else{
            return (
                ""
            )
        }
    }
}

const ActiveButton = styled.button`
    display: inline-block;
    border: 1px solid  var(--main-bg-color);
    background: var(--main-btn-inner-blue);
    color:  var(--main-bg-color);
    padding: 1px 20px;
    text-align: center;
    height: 20px;
    margin-right: 10px;
`

export const MoveUpdatePage = ({keys, data, item, url}) => {
    const navigate = useNavigate();
    const moveUrl = () => {
        navigate(`${url}/${keys}`);
    };

    return (
        <>
            <div className={'flex flex-col justify-center items-center my-1 ml-2'}>
                {data.statusNumericValue == 5 && <ActiveButton className={'hover:bg-[var(--main-bg-color)] hover:text-[white]'} onClick={moveUrl}>접수</ActiveButton>}
            </div>
        </>
    );
};

export {assetNameRenderer}